module.exports = __webpack_public_path__ + "static/media/2A.45630e41.jpg";